<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <b-card>
      <div style="position: relative">
        <div class="d-flex mb-1 w-100 justify-content-end">
          <b-button
            v-can="{ slug: $route.meta.slug, action: 'C' }"
            @click="regulationsModal = true"
            class="d-flex align-items-center"
            variant="success"
          >
            <feather-icon icon="PlusIcon" class="mr-25" />
            إضافة
          </b-button>
        </div>
        <data-table
          ref="regulationsTable"
          :fields="fields"
          :ep="`v2/ministry/regulations/${id}?model=${$route.query.model}`"
          dataPath="data.regulations"
        >
          <template #cell(actions)="{ item }">
            <div class="d-flex pr-2 w-100 justify-content-end">
              <b-dropdown
                variant="link"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>

                <b-dropdown-item
                  v-can="{ slug: $route.meta.slug, action: 'U' }"
                  @click="
                    $refs.regulationsModal.init({
                      id: item.id,
                      regulation_no: item.regulation_no,
                      regulation_date: item.regulation_date,
                      content: item.content,
                      file: item.file,
                    });
                    regulationsModal = true;
                  "
                >
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">تعديل</span>
                </b-dropdown-item>
                <b-dropdown-item
                  :to="{ name: 'regulation-view', params: { id: item.id } }"
                  v-can="{ slug: $route.meta.slug, action: 'S' }"
                >
                  <feather-icon icon="EyeIcon" />
                  <span class="align-middle ml-50">عرض</span>
                </b-dropdown-item>
                <b-dropdown-item
                  @click="onDeleteClicked(item.id)"
                  v-can="{ slug: $route.meta.slug, action: 'D' }"
                >
                  <feather-icon icon="Trash2Icon" />
                  <span class="align-middle ml-50">حذف</span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </data-table>
      </div>
    </b-card>
    <form-modal
      static
      ref="regulationsModal"
      title="أدخل معلومات التشريع"
      :loading="working"
      :formSchema="regulationsFormSchema"
      v-model="regulationsModal"
      @confirm="onConfirm"
      size="lg"
    >
      <template #file="{ form }">
        <form-file-input
          label="ملف التشريع"
          v-model="form.file"
          accept="application/pdf"
        />
      </template>
      <template #content="{ form }">
        <label for="document" class="mt-1">محتوى التشريع</label>
        <validation-provider
          #default="{ errors }"
          name="محتوى التشريع"
          mode="passive"
          rules="required"
        >
          <quill-editor id="quil-content" v-model="form.content"
          :options="editorOption" />
          <small class="text-danger"> {{ errors[0] }}</small>
        </validation-provider>
      </template>
    </form-modal>
  </div>
</template>

<script>
import {
  BRow,
  BDropdown,
  BDropdownItem,
  BFormFile,
  BCol,
  BCard,
  BButton,
  BFormRadioGroup,
} from "bootstrap-vue";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import { mapActions, mapGetters } from "vuex";
import FormModal from "@/components/FormModal.vue";
import DataTable from "@/components/data-table";
import { ValidationProvider } from "vee-validate";
import { required } from "@validations";
import FormFileInput from "@/components/FormFileInput.vue";
export default {
  components: {
    BRow,
    BDropdown,
    BDropdownItem,
    BFormFile,
    BCol,
    BCard,
    BButton,
    BFormRadioGroup,
    ToastificationContent,
    MinistryBreadcrumbs,
    FormFileInput,
    FormModal,
    DataTable,
    quillEditor,
    ValidationProvider,
  },

  props: ["id"],

  data() {
    return {
      required,
      regulationsModal: false,
      mainTitle: "التعاميم الناظمة لعمل المنظمات",
      filter: "both",
      
      editorOption: {
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'],
          ]
        }
      },
      fields: [
        {
          key: "id",
          label: "المعرف",
        },
        {
          key: "regulation_no",
          label: "رقم التشريع",
        },

        {
          key: "regulation_date",
          label: "تاريخ التشريع",
        },
        // {
        //   key: "RegulationType.name_ar",
        //   label: "نوع التشريع",
        // },

        {
          key: "actions",
          label: "",
        },
      ],

      regulationsFormSchema: {
        regulation_no: {
          component: "FormInput",
          key: "regulation_no",
          attrs: {
            label: "رقم التشريع",
            rules: "required",
          },
        },
        regulation_date: {
          component: "FormMask",
          key: "regulation_date",
          attrs: {
            options: "date",
            placeholder: "YYYY-MM-DD",
            label: "تاريخ التشريع",
            rules: "required",
          },
        },

        // regulation_type_id: {
        //   component: "FormSelect",
        //   key: "regulation_type_id",
        //   attrs: {
        //     id: "faq-category",
        //     label: "نوع التشريع",
        //     ep: `v2/ministry/selects/regulation-types?model=${this.$route.query.model}`,
        //     reduce: (x) => x.id,
        //     getOptionLabel: (x) => x.name_ar,
        //     rules: "required",
        //   },
        // },
        file: {
          key: "file",
        },
        content: {
          key: "content",
        },
      },
      breadcrumbs: [
        {
          text: "الإعدادات",
          to: "/ministry/settings",
        },
        {
          text: "التعاميم الناظمة لعمل المنظمات",
          active: true,
        },
      ],
    };
  },

  computed: {
    ...mapGetters("Ministry/Settings/Regulations", ["working"]),
  },
  methods: {
    ...mapActions("Ministry/Settings/Regulations", [
      "editRegulation",
      "addRegulation",
      "deleteRegulation",
    ]),
    setFilter(filter) {
      this.filter = filter;
    },
    async onConfirm(form) {
      const toUpdate = { ...form };
      if (form.id) {
        const toUpdate = { ...form };
        if (typeof toUpdate.file === "string") delete toUpdate.file;
        await this.editRegulation({
          form: { ...toUpdate, regulation_type_id: this.$route.params.id },
          model: this.$route.query.model,
        });
      } else {
        await this.addRegulation({
          form: { ...form, regulation_type_id: this.$route.params.id },
          model: this.$route.query.model,
        });
      }
      this.regulationsModal = false;
      this.$refs.regulationsTable.refreshTable();
    },

    onDeleteClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف التشريع ؟", {
          title: "تأكيد حذف التشريع",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            await this.deleteRegulation(id);
            this.$refs.regulationsTable.refreshTable();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
